export function getQueryParam(name: string): string | null {
  const params = new URLSearchParams(window.location.search);
  const q = params.get(name);
  if (q) return q;
  return null;
}

export function emailValid(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function sanitizePhone(phone: string): string {
  const raw = phone.trim();
  const hasLeadingPlus = raw.startsWith('+');
  const digits = raw.replace(/\D/g, '').slice(0, 15);
  return `${hasLeadingPlus ? '+' : ''}${digits}`;
}

export function phoneValid(phone: string): boolean {
  const sanitized = sanitizePhone(phone);
  const digits = sanitized.replace(/\D/g, '');
  return /^\+?\d+$/.test(sanitized) && digits.length >= 9 && digits.length <= 15;
}
